module.exports = __webpack_public_path__ + "media/images/logo_fa-411e39c5.jpg";